import styles from '../article.module.css';

import { Timeline } from 'react-twitter-widgets';

export const StyledTwitterTimeline = (props: StyledTwitterTimelineProps) => {
    const { id, height, fixedheight, bleed, name } = props;
    return (
        <TwitterTimeline
            id={id}
            height={parseInt(`${height}`)}
            fixedHeight={fixedheight === 'on'}
            bleed={bleed === 'on'}
            name={name}
        />
    );
};

interface StyledTwitterTimelineProps {
    id: string;
    name: string;
    bleed: string;
    fixedheight: string;
    height: string | number;
}

export const TwitterTimeline = (props: TwitterProps) => {
    const { id, name, bleed, height, fixedHeight } = props;
    const containerStyle: any = {};

    if (fixedHeight && height) {
        containerStyle.height = height;
        containerStyle.minHeight = height;
        containerStyle.maxHeight = height;
    }

    const className = [styles['twitter'], 'media'];
    if (bleed) {
        className.push('bleed');
    }

    return (
        <div id={id} style={containerStyle} className={className.join(' ')}>
            <Timeline
                dataSource={{
                    sourceType: 'profile',
                    screenName: name,
                }}
                options={{
                    height: '100%',
                }}
            />
        </div>
    );
};

interface TwitterProps {
    id: string;
    name: string;
    bleed: boolean;
    height: number;
    fixedHeight: boolean;
}
